import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
//import { InterventionsPdfService } from '@app/shared/services/entities/interventions-pdf.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
import { StockService } from '@app/shared/services/entities/stock.service';
import { UsersService } from '@app/shared/services/entities/users.service';
import { Observable, map, startWith } from 'rxjs';
import { InterventionsSuitcaseProductComponent } from '../interventions-suitcase-product/interventions-suitcase-product.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
//import { InterventionsTrayComponent } from '../interventions-tray/interventions-tray.component';



const log = new LoggerService('INTERVENTION DELIVERY DIALOG COMPONENT');

import { isValidRfidTag, rfidTagValidators, RFID_TAG_ERROR } from '@app/shared/utils/rfid';
@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-interventions-delivery-dialog',
  templateUrl: './interventions-delivery-dialog.component.html',
  styleUrls: ['./interventions-delivery-dialog.component.scss']
})
export class InterventionsDeliveryDialogComponent implements OnInit {

  public interventionForm: FormGroup;
  public tagRfidForm: FormGroup;
  public userWarehouse = null;
  public userCustomParams = null;
  public contractItem = null;
  public contract = null;
  public record = null;
  public doctorObject = null;
  public hospitalObject = null;
  public operationRoomObject = null;
  public patientObject = null;
  public placesObject = null;
  public procedureObject = null;
  public kitObject = null;
  public productObject = null;
  public specialtyObject = null;
  public warehousesObject = null;
  public contractList = [];
  public itemList = [];
  public placesList = [];
  public kitList = [];
  public productList = [];
  public substituteList = null;
  public substituteColumns = ['itemNumber', 'itemDescription', 'quantity', 'comment'];

  public warehousesList = [];
  public delivery = [];
  public refund = [];
  public itemInputs = [
    {
      'name': 'code',
      'displayName': 'Código',
      'type': 'autocomplete',
      'options': [],
      'required': true
    },
    {
      'name': 'batch',
      'displayName': 'Lote',
      'type': 'text',
      'required': true
    },
    {
      'name': 'expiration',
      'displayName': 'Caducidad',
      'type': 'date',
      'required': true
    }
  ];

  public dataSource = null;
  public displayedColumns = ['itemNumber', 'itemDescription', 'quantity', 'delivery', 'comment'];

  // ✅ Tablas por categoría del request
  public categoryTables: { key: string; label: string; dataSource: MatTableDataSource<any> }[] = [];
  public categoryColumns = ['itemCode', 'itemDescription', 'quantity', 'delivery', 'type'];
  public categoryLabels: { [key: string]: string } = {
    products:      'Insumos',
    equipments:    'Equipos',
    medicines:     'Medicamentos',
    instrumentals: 'Instrumental'
  };

  // ✅ Opciones para el selector de categoría en el form de RFID
  public categoryOptions = [
    { key: 'products',      label: 'Insumos'    },
    // { key: 'equipments',    label: 'Equipos'      },
    // { key: 'medicines',     label: 'Medicamentos' },
    // { key: 'instrumentals', label: 'Instrumental' },
  ];


  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<InterventionsDeliveryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService,
    private inventoryService: StockService,
    private interventionsService: InterventionsService,
    private usersService: UsersService,
    public dialog: MatDialog
  ) { }

  async ngOnInit() {
    this.customMessageService.open({
      title: "Espere",
      type: 'success',
      message: 'Cargando información ',
      duration: 2000,
      loading: true,
    });

    //log.debug(this.data)
    this.record = this.data['record'];
    this.doctorObject = this.data['doctor'];
    this.patientObject = this.data['patient'];
    this.procedureObject = this.data['procedure'];
    this.specialtyObject = this.data['specialty'];
    this.contractList = this.data['contract'];
    this.kitList = this.data['kit'];
    this.kitObject = this.data['kitObject'];
    this.productList = this.data['product'];
    this.productObject = this.data['productObject'];
    this.placesList = this.data['places'];
    this.placesObject = this.data['placesObject'];
    this.warehousesList = this.data['warehouses'];
    this.warehousesObject = this.data['warehousesObject'];
    this.userWarehouse = this.data['userWarehouse'];
    this.userCustomParams = this.data['customParams'];
    this.contractItem = this.data['contract'];
    this.contract = this.record['contract'];

    if (!Array.isArray(this.contract)) {
      this.contract = this.contract ? [this.contract] : [];
    }

    // ✅ FormGroup con tagRfid y category
    this.tagRfidForm = this.formBuilder.group({
      tagRfid:  [null, rfidTagValidators()],
      category: [null],
    });

    // VALIDACIÓN: Verificar si order existe y no es null
    let data = [];
    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];
    const request = this.record['request'];

    for (const cat of categories) {
      if (request?.[cat] && Array.isArray(request[cat]) && request[cat].length > 0) {
        data[cat] = request[cat];
        data[cat].forEach((item: any) => item.delivery = 0);
      } else {
        data[cat] = [];
        // Inicializar la categoría en request si no existe, para poder agregar items bcc
        if (request && !request[cat]) {
          request[cat] = [];
        }
      }

      // ✅ Cargar items entregados previamente (ids guardados en record[cat].delivery)
      if (
        this.record[cat]?.['delivery'] &&
        Array.isArray(this.record[cat]['delivery']) &&
        this.record[cat]['delivery'].length > 0
      ) {
        for (const itemId of this.record[cat]['delivery']) {
          const item = await this.getItemById(cat, itemId);
          if (item) {
            this.delivery.push(item);
            this._updateCategoryTable(cat, item);
          }
        }
      }
    }

    this.dataSource = new MatTableDataSource(data);

    // ✅ Construir tablas por categoría desde el request (ya con delivery actualizado)
    this.buildCategoryTables();
  }

  /**
   * @description Construye las tablas de materiales solicitados por categoría.
   *              Solo genera una tabla si la categoría existe y tiene elementos.
   */
  buildCategoryTables() {
    this.categoryTables = [];
    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];
    const request = this.record['request'];

    if (request != null && typeof request === 'object') {
      for (const category of categories) {
        if (Array.isArray(request[category]) && request[category].length > 0) {
          this.categoryTables.push({
            key:        category,
            label:      this.categoryLabels[category] || category,
            dataSource: new MatTableDataSource(request[category])
          });
        }
      }
    }
  }

  /*** @description Da formato a fecha */
  public formatDate(dateString: string): string {
    const testDate = new Date(dateString);
    return testDate.toLocaleDateString('es-ES', {
      day:    '2-digit',
      month:  'long',
      year:   'numeric',
      hour:   'numeric',
      minute: 'numeric',
    });
  }

  /*** @description Busqueda de producto por etiqueta RFID con selector de categoría */
  async getItemByTagRfid() {
    const tagRfid  = this.tagRfidForm.value['tagRfid']?.toUpperCase();
    const category = this.tagRfidForm.value['category'];

    // Validar que ambos campos estén llenos
    if (!tagRfid || !category) {
      await this.customMessageService.open({
        title:      'Información',
        type:       'neutral',
        message:    'Por favor seleccione una categoría e ingrese una etiqueta RFID.',
        dismissBtn: true,
      });
      return;
    }
    if (!isValidRfidTag(tagRfid)) {
      await this.customMessageService.open({ title: 'Etiqueta inválida', type: 'warning', message: RFID_TAG_ERROR, dismissBtn: true });
      return;
    }

    // Verificar duplicado en lista de delivery
    const inList = this.delivery.filter((item) => item['tagRfid'] === tagRfid);
    if (inList.length > 0) {
      await this.customMessageService.open({
        title:      'Información',
        type:       'neutral',
        message:    `Este insumo <b>${tagRfid}</b> ya se encuentra en la lista de consumo.`,
        dismissBtn: true,
      });
      return;
    }

    // try {
      this.customMessageService.open({ title: 'Espere', type: 'neutral', message: 'Buscando insumo...', loading: true });
      let apiResponse = await this.inventoryService.search({ searchType:'default',condition:{tagRfid:tagRfid}  });
      log.debug(apiResponse);
      this.customMessageService.close();

      if (apiResponse['state'] == 'success' && apiResponse['data'][0] != null) {
        let items = apiResponse['data'][0];

        if (items['status'] != 'Disponible') {
          await this.customMessageService.open({
            title:      'Información',
            type:       'neutral',
            message:    `El insumo seleccionado tiene estatus de <b>${items['status']}</b>.<br> Revise que sea correcto.`,
            dismissBtn: true,
          });
          return;
        }

        // Switch por categoría para decorar el item y actualizar la tabla correspondiente
        switch (category) {
          case 'products': {
            items['codeName']            = this.productObject[items['product']]['code'];
            items['codeDescription']     = this.productObject[items['product']]['description'];
            items['name']        = items['codeName'];
            items['description'] = items['codeDescription'];
            items['category']    = category;

            this.delivery.push(items);
            log.debug('this.delivery',this.delivery)
            this._updateCategoryTable(category, items);
            break;
          }

          case 'equipments': {
            items['name']        = this.productObject[items['code']]['code'];
            items['description'] = this.productObject[items['code']]['description'];
            items['category']    = category;

            this.delivery.push(items);
            this._updateCategoryTable(category, items);
            break;
          }

          case 'medicines': {
            items['name']        = this.productObject[items['code']]['code'];
            items['description'] = this.productObject[items['code']]['description'];
            items['category']    = category;

            this.delivery.push(items);
            this._updateCategoryTable(category, items);
            break;
          }

          case 'instrumentals': {
            items['name']        = this.productObject[items['code']]['code'];
            items['description'] = this.productObject[items['code']]['description'];
            items['category']    = category;

            this.delivery.push(items);
            this._updateCategoryTable(category, items);
            break;
          }

          default:
            break;
        }

        this.tagRfidForm.controls['tagRfid'].reset();

      } else if (apiResponse['data'][0] == null) {
        await this.customMessageService.open({ title: 'Error', type: 'error', message: 'Etiqueta RFID no encontrada', dismissBtn: true });
      }
    // } catch (err) {
    //   this.customMessageService.close();
    //   await this.customMessageService.open({ title: 'Error', type: 'error', message: err, dismissBtn: true });
    // }
  }


  /*** @description Busqueda de producto por id, retorna el item decorado con name/description */
  async getItemById(cat: string, itemId: string): Promise<any | null> {
    // try {
      switch (cat) {
        case 'products': {
          let productResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (productResponse.state === 'success' && productResponse.data[0]) {
            let item = productResponse.data[0];
            item['codeName']            = this.productObject[item['product']]['code'];
            item['codeDescription']     = this.productObject[item['product']]['description'];
            item['codeItemNumber']     = this.productObject[item['product']]['itemNumber'];
            item['name']        = item['codeName'];
            item['description'] = item['codeDescription'];
            item['itemNumber'] = item['codeItemNumber'];
            item['category']    = cat;
            return item;
          }
          return null;
        }
        case 'equipments': {
          let equipmentResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (equipmentResponse.state === 'success' && equipmentResponse.data[0]) {
            let item = equipmentResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        case 'medicines': {
          let medicineResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (medicineResponse.state === 'success' && medicineResponse.data[0]) {
            let item = medicineResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        case 'instrumentals': {
          let instrumentalResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (instrumentalResponse.state === 'success' && instrumentalResponse.data[0]) {
            let item = instrumentalResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        default:
          return null;
      }
    // } catch (err) {
    //   this.customMessageService.close();
    //   await this.customMessageService.open({ title: 'Error', type: 'error', message: err, dismissBtn: true });
    //   return null;
    // }
  }

  /**
   * @description Actualiza el request y el MatTableDataSource de la categoría indicada.
   *              Si el item no existe en el request lo agrega con tipo 'bcc'.
   */
  private _updateCategoryTable(category: string, item: any) {
    const request = this.record['request'];
    const requestItems: any[] = request?.[category] ?? [];

    const matchIndex = requestItems.findIndex((r: any) => r.itemCode === item['name']);

    if (matchIndex !== -1) {
      // Existe en el request → incrementar delivery
      requestItems[matchIndex].delivery = (requestItems[matchIndex].delivery || 0) + 1;
    } else {
      // No existe → agregar como bcc
      requestItems.push({
        itemCode:        item['name'],
        itemDescription: item['description'],
        itemNumber: item['itemNumber'],
        quantity:        0,
        delivery:        1,
        consumption:     0,
        refund:          0,
        type:            'bcc'
      });
      if (request && !request[category]) {
        request[category] = requestItems;
      }
    }

    // Refrescar el MatTableDataSource de la tabla correspondiente
    const tableEntry = this.categoryTables.find(t => t.key === category);
    if (tableEntry) {
      tableEntry.dataSource.data = [...requestItems];
    } else {
      // La tabla no existía aún (categoría vacía) → crearla
      this.categoryTables.push({
        key:        category,
        label:      this.categoryLabels[category] || category,
        dataSource: new MatTableDataSource([...requestItems])
      });
    }
  }

  /**
   * @description Decrementa delivery en el request para la categoría indicada.
   *              Si el item es de tipo 'bcc' y su delivery llega a 0, lo elimina del request.
   */
  private _removeFromCategoryTable(category: string, item: any) {
    const request = this.record['request'];
    const requestItems: any[] = request?.[category] ?? [];

    const matchIndex = requestItems.findIndex((r: any) => r.itemCode === item['name']);

    if (matchIndex !== -1) {
      requestItems[matchIndex].delivery = (requestItems[matchIndex].delivery || 1) - 1;

      // Si es bcc y llegó a 0 → eliminar del array
      if (requestItems[matchIndex].type === 'bcc' && requestItems[matchIndex].delivery <= 0) {
        requestItems.splice(matchIndex, 1);
      }
    }

    // Refrescar el MatTableDataSource de la tabla correspondiente
    const tableEntry = this.categoryTables.find(t => t.key === category);
    if (tableEntry) {
      tableEntry.dataSource.data = [...requestItems];
    }
  }

  /*** @description Elimina elemento */
  async deleteItem(item: any) {
    //log.debug(item);
    let response = await this.customMessageService.open({
      title:         'Información',
      type:          'neutral',
      message:       `Esta de acuerdo en remover el insumo con etiqueta ${item.tagRfid} de la lista.`,
      dismissBtn:    true,
      acceptBtn:     true,
      acceptBtnText: 'Continuar'
    });
    //log.debug(response);
    if (!response) return;
    this.refund.push(item);
    this.delivery = this.delivery.filter(x => x.id !== item.id);
    // ✅ Usar _removeFromCategoryTable para decrementar delivery en el request
    //    y eliminar el item si es bcc y llega a 0
    const category = item['category'];
    if (category) {
      this._removeFromCategoryTable(category, item);
    }
  }

  async save() {
    let data: any = {};
    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];

    // ✅ Construir data por categoría y actualizar estatus de productos
    for (const cat of categories) {
      const deliveryItems = this.delivery.filter(item => item['category'] === cat);
      const refundItems   = this.refund.filter(item => item['category'] === cat);

      data[cat] = { delivery: deliveryItems.map(item => item.id) };

      if (deliveryItems.length > 0) await this.changeProductStatus(deliveryItems, 'Transito', cat);
      if (refundItems.length > 0)   await this.changeProductStatus(refundItems, 'Disponible', cat);
    }

    data['id'] = this.record['id'];
    data['request'] = this.record['request'];
    //log.debug(data);

    let intervention = await this.pacthInterventions(data);
    if (!intervention) return;
    this.dialogRef.close(intervention);
  }

  /**
   * @description Edición de intervención
   */
  async pacthInterventions(data: any) {
    this.customMessageService.open({
      title:    'Espere',
      type:     'neutral',
      message:  'Guardando programación quirúrgica',
      duration: 2000,
      loading:  true,
    });
    data['operationType'] = 'single';
    data['modifiedBy'] = sessionStorage.getItem('userId');
    let apiResponse = await this.interventionsService.update(data);
    //log.debug(apiResponse);
    this.customMessageService.close();
    if (apiResponse['state'] == 'success') {
      await this.customMessageService.open({
        title:    '¡Hecho!',
        type:     'success',
        message:  apiResponse['message'],
        duration: 2000,
      });
      return apiResponse['data'][0];
    } else {
      await this.customMessageService.open({
        title:    'Error',
        type:     'error',
        message:  apiResponse['message'],
        duration: 2000,
      });
    }
  }

  async changeProductStatus(data: any, status: string, category: string) {
    try {
      // ✅ Construir array de objetos con id, tagRfid y status para envío en lote
      const records = data.map((item: any) => ({
        id:      item['id'],
        tagRfid: item['tagRfid'],
        status:  status
      }));
      log.debug(records);

      this.customMessageService.open({ title: 'Espere', type: 'success', message: `Actualizando estatus de insumos...`, loading: true });

      let apiResponse: any;
      switch (category) {
        case 'products': {
          apiResponse = await this.inventoryService.update({ operationType: 'multiple', records });
          break;
        }
        case 'equipments': {
          apiResponse = await this.inventoryService.update({ operationType: 'multiple', records });
          break;
        }
        case 'medicines': {
          apiResponse = await this.inventoryService.update({ operationType: 'multiple', records });
          break;
        }
        case 'instrumentals': {
          apiResponse = await this.inventoryService.update({ operationType: 'multiple', records });
          break;
        }
        default: {
          apiResponse = await this.inventoryService.update({ operationType: 'multiple', records });
          break;
        }
      }

      //log.debug(apiResponse)
      this.customMessageService.close();
      if (apiResponse['state'] == 'success') {
        await this.customMessageService.open({ title: '¡Hecho!', type: 'success', message: 'Insumos actualizados correctamente', duration: 3000 });
      } else {
        await this.customMessageService.open({ title: 'Error', type: apiResponse['state'], message: apiResponse['message'], dismissBtn: true });
      }
    } catch (err) {
      this.customMessageService.close();
      await this.customMessageService.open({ title: 'Error', type: 'error', message: err, dismissBtn: true });
    }
  }

  async getUsersById(userId: string) {
    let httpResponse: any = await this.usersService.getUsersById({ id: userId });
    return httpResponse['data'];
  }

  addSuitcaseProduct(mode: string) {
    const dialogRef = this.dialog.open(InterventionsSuitcaseProductComponent, {
      width: '90%',
      data: {
        mode:     mode,
        contract: this.contractList,
        products: this.productList
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //log.debug("result",result)
        result.forEach(element => {
          log.debug(element);

          element['codeName']            = this.productObject[element['code']]['code'];
          element['codeDescription']     = this.productObject[element['code']]['description'];
          element['codeContract']        = this.contract ? this.contract.find(ele => ele in this.productObject[element['code']]['itemNumber']) : undefined;
          log.debug(`element['codeContract']`, element['codeContract']);
          element['codeItemNumber']      = element['codeContract'] ? this.productObject[element['code']]['itemNumber'][element['codeContract']] : undefined;
          element['codeItemDescription'] = this.itemList.find(ele => ele['contract'] === element['codeContract'] && String(ele['itemNumber']) === String(element['codeItemNumber']))
            ? this.itemList.find(objeto => objeto['contract'] === element['codeContract'] && String(objeto['itemNumber']) === String(element['codeItemNumber']))['itemDescription']
            : '';

          this.delivery.push(element);
          const data = this.dataSource.data;
          const indice = data.findIndex(objeto => objeto.itemNumber === element['codeItemNumber'] && objeto.contract === element['codeContract']);
          if (indice !== -1) {
            data[indice].delivery++;
          } else {
            data.push({ itemNumber: element['codeItemNumber'], itemDescription: element['codeItemDescription'], quantity: 0, delivery: 1, comment: '', status: true, contract: element['codeContract'] });
          }
          this.dataSource.data = data;

          //log.debug(this.delivery)
        });
      }
    });
  }

  // Método helper para mostrar mensajes de advertencia
  private async showWarningMessages(lists: any) {
    const warnings = [
      { list: lists.duplicateList,   message: 'Las siguientes etiquetas ya se encuentran en la intervención:' },
      { list: lists.expiredList,     message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Caduco:' },
      { list: lists.consumptionList, message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Consumido:' },
      { list: lists.refundList,      message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Devolución:' },
      { list: lists.diffList,        message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Diferencia Inventario:' },
      { list: lists.transitList,     message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Transito:' },
      { list: lists.sendist,         message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Envio:' },
      { list: lists.wastwList,       message: 'Las siguientes etiquetas no se añadieron en la intervención porque tienen estado de Merma:' },
    ];

    for (const warning of warnings) {
      if (warning.list && warning.list.length > 0) {
        const tagRfids = warning.list
          .filter(item => item && item.tagRfid)
          .map(item => item.tagRfid);

        if (tagRfids.length > 0) {
          const errorMessage = warning.message + '\n' + tagRfids.join('\n');
          await this.customMessageService.open({
            title:      'Advertencia de Intervención',
            type:       'warning',
            message:    errorMessage + '\n\nSe continuará con el guardado.',
            dismissBtn: true
          });
        }
      }
    }
  }

}